import api from './api';

const ENDPOINT = 'form-recipients';

const FormRecipientsService = {
  get: () => api.get(`${ENDPOINT}`),
  getByType: (type) => api.get(`${ENDPOINT}/${type}/bytype`),
  getId: (id) => api.get(`${ENDPOINT}/${id}`),
  update: (id, data) => api.put(`${ENDPOINT}/${id}`, data),
  delete: (id) => api.delete(`${ENDPOINT}/${id}`),
  save: (data) => api.post(`${ENDPOINT}`, data),
};

export default FormRecipientsService;
